import type { UserDTO } from '../api/types';
import type { User } from '../model/types';

export const mapUser = (dto: UserDTO): User => {
  return {
    id: dto.id,
    email: dto.email,
    role: dto.role,
    isActive: dto.isActive,
    ...(dto.lastSignInAt ? { lastSignInAt: dto.lastSignInAt } : {}),
    rlsFilters: [...dto.rlsFilters.dimensionFilters],
    clsFilters: dto.clsFilters,
    viewsRestrictions: dto.viewsRestrictions,
  };
};
